var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loaded)?_c('editor',{ref:"text",staticClass:"formatTextComponent",class:{isOverflowing: _vm.isOverflowing},attrs:{"init":_vm.init,"value":_vm.properties.text}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }